import { render } from "./AudioTestItemResult.vue?vue&type=template&id=1979e7a5&scoped=true"
import script from "./AudioTestItemResult.vue?vue&type=script&lang=js"
export * from "./AudioTestItemResult.vue?vue&type=script&lang=js"

import "./AudioTestItemResult.vue?vue&type=style&index=0&id=1979e7a5&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1979e7a5"]])

export default __exports__